import * as React from 'react';

const THead: React.FC<any> = ({ children }) => <thead>{children}</thead>;

export default THead;
